import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=e328b786&scoped=true&"
import script from "./ProductCategory.vue?vue&type=script&lang=js&"
export * from "./ProductCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e328b786",
  null
  
)

export default component.exports